import React from 'react';

const TermsAndConditions = () => {
  return (
    <div className="min-h-screen bg-gradient-to-b from-white via-pink-50 to-white py-8 md:py-12 lg:py-16">
      <div className="max-w-4xl mx-auto px-4">
        
        {/* Header */}
        <div className="text-center mb-8 md:mb-12">
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-3 md:mb-4 font-display">
            Terms & Conditions
          </h1>
          <p className="text-lg md:text-xl text-gray-600">
            Dear Bea Flowers
          </p>
        </div>

        {/* Content */}
        <div className="bg-white rounded-2xl md:rounded-3xl shadow-xl p-6 md:p-8 lg:p-10">
          <div className="prose prose-sm md:prose-base lg:prose-lg max-w-none">
            
            <p className="text-gray-700 mb-6 md:mb-8 leading-relaxed">
              By placing an order with Dear Bea, you agree to the following Terms & Conditions. Please read them carefully before purchasing.
            </p>

            {/* 1. Orders & Payments */}
            <section className="mb-6 md:mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4 font-display">
                1. Orders & Payments
              </h2>
              <ul className="space-y-2 text-gray-700 list-disc pl-5 md:pl-6">
                <li>All orders must be paid in full to be confirmed unless otherwise stated.</li>
                <li>Prices are listed in AUD and are subject to change without notice.</li>
                <li>Seasonal pricing (including Valentine's Day, Mother's Day, and other peak periods) reflects market flower costs, labour, and demand.</li>
              </ul>
            </section>

            {/* 2. Made-to-Order & Custom Items */}
            <section className="mb-6 md:mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4 font-display">
                2. Made-to-Order & Custom Items
              </h2>
              <ul className="space-y-2 text-gray-700 list-disc pl-5 md:pl-6">
                <li>All arrangements are made to order.</li>
                <li>Custom orders (including bespoke bouquets, keepsake items, and event florals) are final once confirmed.</li>
                <li>Requests for changes must be made at least 72 hours prior to the scheduled pickup or delivery date and are subject to availability.</li>
              </ul>
            </section>

            {/* 3. Flowers & Substitutions */}
            <section className="mb-6 md:mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4 font-display">
                3. Flowers & Substitutions
              </h2>
              <ul className="space-y-2 text-gray-700 list-disc pl-5 md:pl-6">
                <li>Flowers are subject to seasonal availability.</li>
                <li>We cannot guarantee specific flower varieties unless explicitly agreed upon in writing.</li>
                <li>If a specific flower is unavailable, we reserve the right to substitute with blooms of equal or greater value, while maintaining the overall colour palette and style.</li>
                <li>Natural variations in colour, size, and arrangement are expected and are not considered faults.</li>
              </ul>
            </section>

            {/* 4. Ribbon Rose Orders */}
            <section className="mb-6 md:mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4 font-display">
                4. Ribbon Rose Orders
              </h2>
              <ul className="space-y-2 text-gray-700 list-disc pl-5 md:pl-6">
                <li>Ribbon rose arrangements are handmade and require a minimum of 14 days' notice.</li>
                <li>Orders placed with less than 14 days' notice will incur a late order fee of 10-25% of the product price, subject to availability.</li>
                <li>Late ribbon rose orders may be declined at the discretion of Dear Bea.</li>
                <li>During peak periods, ribbon rose orders may close earlier than advertised.</li>
              </ul>
            </section>

            {/* 5. Valentine's Day & Peak Periods */}
            <section className="mb-6 md:mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4 font-display">
                5. Valentine's Day & Peak Periods
              </h2>
              <ul className="space-y-2 text-gray-700 list-disc pl-5 md:pl-6">
                <li>Valentine's Day, Mother's Day, and other peak periods have strict cut-off times.</li>
                <li>Orders placed during peak periods are non-refundable.</li>
                <li>Delivery times during peak periods are provided as time windows only and cannot be guaranteed.</li>
              </ul>
            </section>

            {/* 6. Pickup & Delivery */}
            <section className="mb-6 md:mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4 font-display">
                6. Pickup & Delivery
              </h2>
              <ul className="space-y-2 text-gray-700 list-disc pl-5 md:pl-6">
                <li>All pickup and delivery dates and times are subject to confirmation.</li>
                <li>Requested dates or times are not guaranteed until confirmed by Dear Bea.</li>
                <li>Customers will be notified once their pickup or delivery details are confirmed.</li>
                <li>We are not responsible for delays caused by incorrect addresses, recipient unavailability, weather conditions, or unforeseen circumstances.</li>
                <li>If no one is available to receive a delivery, the order may be left in a safe location at the customer's risk or redelivery fees may apply.</li>
              </ul>
            </section>

            {/* 7. Collaborations & Bundled Products */}
            <section className="mb-6 md:mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4 font-display">
                7. Collaborations & Bundled Products
              </h2>
              <ul className="space-y-2 text-gray-700 list-disc pl-5 md:pl-6">
                <li>Some products may include collaborations (e.g. balloon arrangements).</li>
                <li>Bundle pricing reflects a combined offer and may differ from individual item pricing.</li>
                <li>Individual component prices are provided as a guide only and are subject to change.</li>
                <li>Bundle discounts are applied at our discretion.</li>
              </ul>
            </section>

            {/* 8. Refunds, Cancellations & Issues */}
            <section className="mb-6 md:mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4 font-display">
                8. Refunds, Cancellations & Issues
              </h2>
              <ul className="space-y-2 text-gray-700 list-disc pl-5 md:pl-6">
                <li>Due to the perishable and custom nature of our products, refunds are not available for change of mind.</li>
                <li>Cancellations must be requested at least 48 hours prior to the scheduled pickup or delivery time.</li>
                <li>Orders cancelled outside this window may forfeit all or part of the payment.</li>
                <li>Any issues must be reported within 24 hours of delivery or pickup, accompanied by clear photos.</li>
              </ul>
            </section>

            {/* 9. Care & Longevity */}
            <section className="mb-6 md:mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4 font-display">
                9. Care & Longevity
              </h2>
              <ul className="space-y-2 text-gray-700 list-disc pl-5 md:pl-6">
                <li>Flower longevity varies depending on environmental conditions and care.</li>
                <li>We are not responsible for reduced lifespan caused by heat exposure, improper handling, or lack of care after delivery or pickup.</li>
              </ul>
            </section>

            {/* 10. Images & Marketing */}
            <section className="mb-6 md:mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4 font-display">
                10. Images & Marketing
              </h2>
              <ul className="space-y-2 text-gray-700 list-disc pl-5 md:pl-6">
                <li>Product images are provided as a style and size reference only.</li>
                <li>Exact replication of arrangements is not guaranteed.</li>
                <li>By placing an order, you consent to Dear Bea using images of your order for marketing and promotional purposes unless requested otherwise in writing.</li>
              </ul>
            </section>

            {/* 11. Website Use & Intellectual Property */}
            <section className="mb-6 md:mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4 font-display">
                11. Website Use & Intellectual Property
              </h2>
              <ul className="space-y-2 text-gray-700 list-disc pl-5 md:pl-6">
                <li>All original website content, images, branding, and designs are the property of Dear Bea.</li>
                <li>Some images used on this website may be for reference or inspiration purposes only, particularly for upcoming or seasonal products.</li>
                <li>Third-party images are used solely to illustrate style, size, or concept and remain the property of their respective owners.</li>
                <li>Content may not be copied, reproduced, or used without written permission from Dear Bea or the original content owner.</li>
                <li>Product photos are indicative only. Actual products may vary slightly in appearance once available.</li>
              </ul>
            </section>

            {/* 12. Limitation of Liability */}
            <section className="mb-6 md:mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4 font-display">
                12. Limitation of Liability
              </h2>
              <p className="text-gray-700">
                To the fullest extent permitted by law, Dear Bea is not liable for indirect, incidental, or consequential damages arising from the use of our products or services.
              </p>
            </section>

            {/* 13. Flower Subscriptions */}
<section className="mb-6 md:mb-8">
  <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4 font-display">
    13. Flower Subscriptions
  </h2>
  
  <h3 className="text-xl md:text-2xl font-semibold text-gray-800 mb-2 md:mb-3 mt-4">Subscription Overview</h3>
  <ul className="space-y-2 text-gray-700 list-disc pl-5 md:pl-6">
    <li>Dear Bea offers recurring flower subscription services ("Subscriptions") billed on a monthly basis.</li>
    <li>Subscriptions include seasonal floral arrangements delivered or available for pickup at the agreed frequency.</li>
  </ul>

  <h3 className="text-xl md:text-2xl font-semibold text-gray-800 mb-2 md:mb-3 mt-4">Billing & Payments</h3>
  <ul className="space-y-2 text-gray-700 list-disc pl-5 md:pl-6">
    <li>Subscription payments are charged automatically at the start of each billing cycle.</li>
    <li>By purchasing a subscription, you authorise Dear Bea to charge the payment method provided on a recurring basis.</li>
    <li>Prices are listed in AUD and may be updated with prior notice.</li>
  </ul>

  <h3 className="text-xl md:text-2xl font-semibold text-gray-800 mb-2 md:mb-3 mt-4">Minimum Commitment</h3>
  <ul className="space-y-2 text-gray-700 list-disc pl-5 md:pl-6">
    <li>Subscriptions require a minimum commitment of 3 months, unless otherwise stated.</li>
    <li>Early cancellations within the minimum commitment period are not eligible for refunds.</li>
  </ul>

  <h3 className="text-xl md:text-2xl font-semibold text-gray-800 mb-2 md:mb-3 mt-4">Deliveries & Scheduling</h3>
  <ul className="space-y-2 text-gray-700 list-disc pl-5 md:pl-6">
    <li>Delivery or pickup dates are subject to confirmation and may vary slightly depending on availability.</li>
    <li>Exact delivery times are not guaranteed; time windows may be provided.</li>
    <li>Missed deliveries due to incorrect details or recipient unavailability are not refundable.</li>
  </ul>

  <h3 className="text-xl md:text-2xl font-semibold text-gray-800 mb-2 md:mb-3 mt-4">Flowers & Substitutions</h3>
  <ul className="space-y-2 text-gray-700 list-disc pl-5 md:pl-6">
    <li>Subscription arrangements use seasonal flowers selected by Dear Bea.</li>
    <li>Specific flower varieties or colours cannot be guaranteed.</li>
    <li>Substitutions of equal or greater value may be made to ensure quality and freshness.</li>
  </ul>

  <h3 className="text-xl md:text-2xl font-semibold text-gray-800 mb-2 md:mb-3 mt-4">Pausing or Skipping a Month</h3>
  <ul className="space-y-2 text-gray-700 list-disc pl-5 md:pl-6">
    <li>Subscriptions may be paused or skipped with at least 7 days' notice prior to the next billing date.</li>
    <li>Requests made after this timeframe may apply to the following month.</li>
  </ul>

  <h3 className="text-xl md:text-2xl font-semibold text-gray-800 mb-2 md:mb-3 mt-4">Cancellations</h3>
  <ul className="space-y-2 text-gray-700 list-disc pl-5 md:pl-6">
    <li>After the minimum commitment period, subscriptions may be cancelled with at least 7 days' notice before the next billing date.</li>
    <li>No refunds are provided for subscription payments already processed.</li>
  </ul>

  <h3 className="text-xl md:text-2xl font-semibold text-gray-800 mb-2 md:mb-3 mt-4">Peak Periods</h3>
  <ul className="space-y-2 text-gray-700 list-disc pl-5 md:pl-6">
    <li>During peak periods (including Valentine's Day and Mother's Day), subscription deliveries may be adjusted or substituted with equivalent seasonal arrangements.</li>
    <li>Additional charges may apply if customers request upgrades during peak periods.</li>
  </ul>

  <h3 className="text-xl md:text-2xl font-semibold text-gray-800 mb-2 md:mb-3 mt-4">Subscription Changes</h3>
  <ul className="space-y-2 text-gray-700 list-disc pl-5 md:pl-6">
    <li>Dear Bea reserves the right to modify subscription offerings, pricing, or availability with reasonable notice.</li>
    <li>Customers will be notified of any significant changes prior to billing.</li>
  </ul>
</section>

 {/* 14. Contact */}
            <section className="mb-6 md:mb-8">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-3 md:mb-4 font-display">
                14. Contact
              </h2>
              <p className="text-gray-700 mb-3">
                For any questions regarding these Terms & Conditions, please contact us via:
              </p>
              <div className="space-y-2 text-gray-700">
                <p>📧 <a href="mailto:dearbea.flowers@gmail.com" className="text-rose-600 hover:text-rose-700 font-semibold">dearbea.flowers@gmail.com</a></p>
                <p>📸 Instagram: <a href="https://instagram.com/dearbea.flowers" target="_blank" rel="noopener noreferrer" className="text-rose-600 hover:text-rose-700 font-semibold">@dearbea.flowers</a></p>
              </div>
            </section>

            {/* Last Updated */}
            <div className="mt-8 md:mt-12 pt-6 md:pt-8 border-t border-gray-200">
              <p className="text-sm text-gray-500 text-center">
                Last updated: {new Date().toLocaleDateString('en-AU', { year: 'numeric', month: 'long', day: 'numeric' })}
              </p>
            </div>

          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;